  // --- FadeIn Animation
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mv .fade__In').forEach(el => {
      el.classList.add('is-visible');
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.1
    });
    const isPC = window.innerWidth >= 768;
    // document.querySelectorAll('.fade__In').forEach(el => {
    //   if (el.closest('.mv')) return;
    //   if (isPC && el.closest('.item_info')) return;
    //   observer.observe(el);
    // });
    document.querySelectorAll('.fade__In').forEach(el => {
      if (el.closest('.mv')) return;
      if (isPC && el.closest('.item_info')
      &&
      !el.closest('.c-taghunter-ashizaru-features')
      ) return;
      observer.observe(el);
    });
  });
